import zeplinColor from 'theme/Color';

export const getCardColor = (
  needsAttention: string,
  dealHealth: string,
  dealHealthName: string,
): { borderColor: string; dotColor: string } => {
  const attentionStatus = needsAttention ? String(needsAttention).toLowerCase() : null;
  const health = dealHealth || dealHealthName;
  const healthLower = health ? String(health).toLowerCase() : '';

  if (attentionStatus === 'overdue' || healthLower === 'overdue') {
    return {
      borderColor: zeplinColor.Error,
      dotColor: zeplinColor.Error,
    };
  }

  if (attentionStatus === 'warning' || healthLower === 'warning') {
    return {
      borderColor: zeplinColor.AlertInfo,
      dotColor: zeplinColor.AlertInfo,
    };
  }

  return {
    borderColor: zeplinColor.Neutral5,
    dotColor: zeplinColor.Success,
  };
};
